<template>
  <div class="dialog-wrap">
    <el-dialog
      title="试卷创建"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      @close="handleClose"
      width="780px"
    >
      <el-form
        class="form"
        :model="dataForm"
        :rules="rules"
        ref="dataForm"
        label-width="100px"
      >
        <el-form-item
          label="试卷名称："
          prop="name"
        >
          <el-input
            v-model="dataForm.name"
            placeholder="请输入试卷名称"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="难度系数："
          prop="difficulty"
        >
          <el-input
            v-model="dataForm.difficulty"
            placeholder="请输入难度系数，0-1之间"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="年份："
          prop="year"
        >
          <el-date-picker
            v-model="dataForm.year"
            type="year"
            placeholder="选择年"
          >
          </el-date-picker>
        </el-form-item>
        <!--         <el-form-item
          label="适合院校"
          prop="colleges"
        >
          <el-select
            v-model="dataForm.colleges"
            placeholder="请选择适合院校"
            filterable
            clearable
            @change="collegeChange"
            style="width:100%;"
          >
            <el-option
              v-for="(item,index) in collegeList"
              :key="index"
              :label="item.name"
              :value="{ value: item.code, label: item.name}"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="适合专业"
          prop="majors"
        >
          <el-select
            v-model="dataForm.majors"
            placeholder="请选择适合专业"
            @change="majorChange"
            clearable
            style="width:100%;"
          >
            <el-option
              v-for="(item,index) in majorList"
              :key="index"
              :label="item.name"
              :value="{ value: item.code, label: item.name}"
            >
              <span>{{ `（${item.code}）${item.name}` }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="适合科目"
          prop="subjects"
        >
          <el-select
            v-model="dataForm.subjects"
            placeholder="请选择适合科目"
            clearable
            style="width:100%;"
            @change="subjectsChange"
          >
            <el-option
              v-for="(item,index) in subjectsList"
              :key="index"
              :label="item.subject_name"
              :value="{ value: item.subject_code, label: item.subject_name}"
            >
            </el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item
          label="适合科目："
          prop="subjects"
        >
          <div class="tag-wrap">
            <el-tag
              class="subject-item"
              size="medium"
              :key="item.id"
              v-for="item in subjects"
              closable
              :disable-transitions="false"
              @close="handleSubjectRemove(item)"
            >
              {{
                  item.college_name
                    ? `${item.college_name}-${item.name}`
                    : item.name
                }}
            </el-tag>
            <el-button
              type="text"
              @click="handleSubjectChoose"
            >选择科目</el-button>
          </div>
        </el-form-item>
        <el-form-item
          label="适合专业："
          prop="majors"
        >
          <div class="tag-wrap">
            <el-tag
              class="subject-item"
              size="medium"
              :key="item.id"
              v-for="item in majors"
              closable
              :disable-transitions="false"
              @close="handleMajorRemove(item)"
            >
              {{ `${item.name}/${item.code}` }}
            </el-tag>
            <el-button
              type="text"
              @click="handleMajorChoose"
            >选择专业</el-button>
          </div>
        </el-form-item>
        <el-form-item
          label="适合院校："
          prop="colleges"
        >
          <div class="tag-wrap">
            <el-tag
              class="subject-item"
              size="medium"
              :key="item.id"
              v-for="item in colleges"
              closable
              :disable-transitions="false"
              @close="handleCollegeRemove(item)"
            >
              {{ `${item.name}` }}
            </el-tag>
            <el-button
              type="text"
              @click="handleCollegeChoose"
            >选择院校</el-button>
          </div>
        </el-form-item>
        <el-form-item
          label="在线状态："
          prop="status"
        >
          <el-switch v-model="dataForm.status"></el-switch>
        </el-form-item>
      </el-form>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="handleClose">取 消</el-button>
        <el-button
          type="primary"
          @click="handleSubmit"
        >确 定</el-button>
      </div>
    </el-dialog>
    <SubjectChoose
      :visible="subjectChooseDialog"
      :subjects="subjects"
      @close="subjectChooseDialog = false"
      @submit="saveSubject"
    ></SubjectChoose>
    <MajorChoose
      :visible="majorChooseDialog"
      :majors="majors"
      @close="majorChooseDialog = false"
      @submit="saveMajor"
    ></MajorChoose>
    <CollegeChoose
      :visible="collegeChooseDialog"
      :colleges="colleges"
      @close="collegeChooseDialog = false"
      @submit="saveCollege"
    ></CollegeChoose>
  </div>
</template>

<script>
import MajorChoose from "@/components/dialog/major/MajorChoose";
import CollegeChoose from "@/components/dialog/college/CollegeChoose";
import SubjectChoose from "@/components/dialog/subject/SubjectChoose";
import { examPaperCreate } from '@/api/exam'
import { collegeList, collegeMajorList, majorSubjectList } from "@/api/common";

export default {
  components: {
    MajorChoose,
    CollegeChoose,
    SubjectChoose
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialogVisible: this.visible,
      dataForm: {},
      rules: {
        name: [{ required: true, message: '请输入试卷名称', trigger: 'blur' }],
        status: [{ required: false, message: '请设置上线状态', trigger: 'change' }]
      },
      subjects: [],
      majors: [],
      colleges: [],
      subjectChooseDialog: false,
      majorChooseDialog: false,
      collegeChooseDialog: false,
      collegeList: [],
      majorList: [],
      subjectsList: [],
    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
      if (val) {
        this.fetchCollege()
      }
    }
  },
  methods: {
    fetchCollege() {
      collegeList({ isPaging: 0 }).then(res => {
        this.collegeList = res.list
      })
    },
    collegeChange(e) {
      this.dataForm.majors = {}
      this.dataForm.subjects = {}
      if (e) {
        this.getMajor(e.value);
      }
    },
    getMajor(college_code) {
      let query = {
        isPaging: 0,
        college_code: college_code,
      };
      collegeMajorList(query).then((res) => {
        this.majorList = res.list;
      });
    },
    majorChange(e) {
      this.dataForm.subjects = {}
      this.subjectsList = []
      if (e) {
        this.getSubjects(this.dataForm.colleges.value, e.value);
      }
      this.$forceUpdate()
    },
    getSubjects(college_code, major_code) {
      let query = {
        isPaging: 0,
        college_code: college_code,
        major_code: major_code,
      };
      majorSubjectList(query).then((res) => {
        this.subjectsList = res.list
      });
    },
    subjectsChange(e) {
      this.$forceUpdate()
    },
    handleSubmit() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          const params = Object.assign({}, this.dataForm, {
            year: this.$moment(this.dataForm.year).format("YYYY"),
            status: this.dataForm.status ? 1 : 0,
            subjects: this.subjects.map(v => {
              return {
                code: v.code,
                college_code: null,
              }
            }),
            majors: this.majors.map(v => {
              return {
                code: v.code,
                college_code: v.college_code ? v.college_code : null,
              }
            }),
            colleges: this.colleges.map(v => {
              return {
                code: v.code,
              }
            }),
            /*             subjects: this.dataForm.subjects ? [{
                          code: this.dataForm.subjects.value,
                          college_code: null,
                        }] : null,
                        majors: this.dataForm.majors ? [{
                          code: this.dataForm.majors.value,
                          college_code: null,
                        }] : null,
                        colleges: this.dataForm.colleges ? [{
                          code: this.dataForm.colleges.value,
                        }] : null, */
          })
          delete this.dataForm.colleges
          delete this.dataForm.majors
          delete this.dataForm.subjects
          examPaperCreate(params).then(res => {
            this.$message.success(`创建成功`)
            this.$refs['dataForm'].resetFields()

            this.$emit('submit', res)
            this.handleClose()
          }).catch(error => {
            console.log('error: ', error)
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    handleClose() {
      this.$emit('close')
    },
    handleSubjectRemove(item) {
      this.subjects = this.subjects.filter((v) => v.id !== item.id);
    },
    handleSubjectChoose() {
      this.subjectChooseDialog = true;
    },
    saveSubject({ subjects }) {
      this.subjects = subjects;
    },
    handleMajorRemove(item) {
      this.majors = this.majors.filter((v) => v.id !== item.id);
    },
    handleMajorChoose() {
      this.majorChooseDialog = true;
    },
    saveMajor({ majors }) {
      this.majors = majors;
    },
    handleCollegeRemove(item) {
      this.colleges = this.colleges.filter((v) => v.id !== item.id);
    },
    handleCollegeChoose() {
      this.collegeChooseDialog = true;
    },
    saveCollege({ colleges }) {
      this.colleges = colleges;
    },
  }
}
</script>

<style lang="less" scoped>
.dialog-wrap {
  .form {
    margin-bottom: -18px;
  }
}

.el-tag {
  margin: 5px;
}
</style>
